export class MomsnummerValideringsstatus {
    static readonly giltig = "Giltig";
    static readonly ogiltig = "Ogiltig";
    static readonly ejValiderad = "EjValiderad";
}
